import React, { useState } from 'react';
import { X, UploadCloud, FileEdit } from 'lucide-react';

interface ActionModalProps {
  task: API.PROJECTHQ.TypeTask | null;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (task: API.PROJECTHQ.TypeTask) => void;
}

export const ActionModal: React.FC<ActionModalProps> = ({ task, isOpen, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen || !task) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    // Simulate network request
    setTimeout(() => {
      setLoading(false);
      onConfirm(task);
      onClose();
    }, 1000);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden animate-fade-in-up">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <h3 className="text-lg font-semibold text-gray-800">办理任务</h3>
          <button onClick={onClose} className="flex items-center justify-center p-1 text-gray-400 hover:text-gray-600 transition-colors">
            <X size={20} />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-6">
            <div className="flex items-center space-x-2 mb-2">
              <span className="bg-blue-100 text-blue-700 text-xs px-2 py-0.5 rounded font-medium">任务</span>
              <span className="font-medium text-gray-700">{task.value}</span>
            </div>
            <p className="text-sm text-gray-500 bg-gray-50 p-3 rounded border border-gray-100">
              {task.statusText || "请根据要求完成相关表单填写或文件上传工作。"}
            </p>
          </div>

          {/* Mock Form Fields */}
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                备注说明 <span className="text-red-500">*</span>
              </label>
              <textarea 
                required
                className="w-full border border-solid border-gray-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all"
                rows={3}
                placeholder="请输入办理情况说明..."
              ></textarea>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                附件上传
              </label>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 flex flex-col items-center justify-center text-gray-400 hover:border-primary hover:text-primary transition-colors cursor-pointer bg-gray-50">
                <UploadCloud size={24} className="mb-2" />
                <span className="text-xs">点击上传相关文件 (Mock)</span>
              </div>
            </div>
          </div>

          <div className="mt-8 flex space-x-3">
            <button 
              type="button" 
              onClick={onClose}
              className="flex-1 py-2 px-4 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors"
            >
              取消
            </button>
            <button 
              type="submit" 
              disabled={loading}
              className="flex-1 py-2 px-4 bg-primary text-white rounded-lg font-medium hover:bg-slate-700 transition-colors flex items-center justify-center"
            >
              {loading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  处理中...
                </>
              ) : (
                <>
                  <FileEdit size={16} className="mr-2" />
                  确认提交
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};